import React, { Component } from 'react';
import moment from 'moment';
import InputMask from 'react-input-mask';
import DatePicker from './dataPicker';
import TimePicker from './timePicker';
import Location from './location';
import Map from '../map';
import './index.css';

class Form extends Component {
    state = {
        openDatePicker: false,
        openTimePicker: false,
        name: null,
        validName: false,
        email: null,
        validEmail: false,
        phone: null,
        validPhone: false,
        address: null,
        validAddress: false,
        showDate: moment().format('DD - MM - YYYY'),
        showTime: moment().format('HH:00 a'),
        dayilyPlan: true,
    }

    

    dataPickerClick = () => {
        this.setState({openDatePicker: true});
    }

    dataPickerClose = () => {
        this.setState({openDatePicker: false});
    }

    handlerCloseTime = () => {
        let TimeShow  = this.state.openTimePicker;
        this.setState({openTimePicker: !TimeShow});
    }

    dataPickerSave = (date) => {
        let time = moment(new Date(date)).format('DD - MM - YYYY');
        this.setState({showDate: time});
        this.setState({openDatePicker: false});
    }

    handlerOpenTimePicker = (time) => {
        this.setState({showTime: time});
    }

    handleDaily = () => {
        let day  = this.state.dayilyPlan;
        if(!day){
            this.setState({dayilyPlan: true})
        }
    }

    handleHourly= () => {
        let day  = this.state.dayilyPlan;
        if(day){
            this.setState({dayilyPlan: false})
        }
    }

    handreOnName = (name) => {
        if(name != ''){
            this.setState({name: name.target.value, validName: true});
        }
        console.log(this.props.carColor)
    }

    handleOnEmail = ( email ) => {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if ( re.test(email.target.value) ) {
            this.setState({email: email.target.value, validEmail: true});
            document.getElementById('booking-form__email').classList.remove('booking__input-error');
        }
        else {
            document.getElementById('booking-form__email').classList.add('booking__input-error');
        }
    }

    handleOnPhone = (phone) => {        
        var re = /^([0-9]( |-)?)?(\(?[0-9]{3}\)?|[0-9]{3})( |-)?([0-9]{3}( |-)?[0-9]{4}|[a-zA-Z0-9]{7})$$/;
        if ( re.test(phone.target.value) ) {
            this.setState({phone: phone.target.value, validPhone: true});
            document.getElementById('booking-form__phone').classList.remove('booking__input-error');
        }
        else {
            document.getElementById('booking-form__phone').classList.add('booking__input-error');
        }
    }

    handleOnAddress = (address) => {
        this.setState({address: address, validAddress: true});
    }

    handleSendForm = () => {
        if(this.state.validAddress && this.state.validName && this.state.validEmail && this.state.validPhone){
            fetch('https://formspree.io/molrjvkx', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    Info: ` 
                    Name: ${this.state.name}
                    E-mail: ${this.state.email}
                    Phone: ${this.state.phone}
                    Address: ${this.state.address}
                    Car Color: ${this.props.carColor}
                    Date: ${this.state.showDate}
                    Time: ${this.state.showTime}
                    Type: ${this.state.dayilyPlan ? 'Dayli' : 'Hourly'}`
                })
            })
        }
    }

    render (){
        return (
            <form className="booking-form">
                <div className="booking-form__wrapper">
                    <div className="booking-form__inputs">
                        <h3 className="booking-form__title">Booking</h3>
                        <label htmlFor="booking-form__name">Name</label>
                        <input type="text" name="name" id="booking-form__name" onBlur={this.handreOnName}/>
                        <label htmlFor="booking-form__email">Email</label>
                        <input type="email" name="name" id="booking-form__email" onBlur={this.handleOnEmail}/>
                        <label htmlFor="booking-form__phone">Phone number</label>
                        <InputMask mask="999 999 9999" type="phone" name="name" id="booking-form__phone" onBlur={this.handleOnPhone}></InputMask>
                        <label htmlFor="booking-form__location">Pickup Location</label>
                        <Location enterLocation={this.props.onAddressChange} location={this.handleOnAddress}/>
                        <div className="booking-form__dates-picker">
                            <div className="booking-form__date">
                                <p className="booking-form__text">Date</p>
                                <div id="booking-form__date" onClick={this.dataPickerClick}>{this.state.showDate ? this.state.showDate : moment().format('DD - MM - YYYY')}</div>
                                {this.state.openDatePicker ? <DatePicker forClose={this.dataPickerClose} forSave={this.dataPickerSave}/> : null}
                            </div>
                            <div className="booking-form__time">
                                <p className="booking-form__text">Time</p>
                                <div id="booking-form__time" className={this.state.openTimePicker ? 'booking-form__time-active' : null } onClick={this.handlerCloseTime}>
                                    {this.state.showTime ? this.state.showTime : moment().format('HH:00 a')} 
                                    {this.state.openTimePicker ? <TimePicker forSave={this.handlerOpenTimePicker} selectedTime={this.state.showTime}/> : null}
                                </div>
                            </div>
                        </div>
                        <div className="booking-form__plan">
                            <div className={this.state.dayilyPlan ? "booking-form__plan-active" : null} onClick={this.handleDaily}>Daily</div>
                            <div className={!this.state.dayilyPlan ? "booking-form__plan-active" : null} onClick={this.handleHourly}>Hourly</div>
                        </div>
                    </div>
                </div>
                <div className="map__wrapper-mobile">
                    <Map enterLat={this.props.enterLat} enterLng={this.props.enterLng}/>
                  </div>
                <h3 className="booking-form__total">
                    Total cost <br/>
                    <span className="booking-form__total-bold">${this.state.dayilyPlan ? '1,200' : '150'}</span>
                     <span className="booking-form__total-small"> per {this.state.dayilyPlan ? 'day' : 'hour'}</span>
                </h3>
                <div className="booking-form__submit" id="booking-form__submit" onClick={this.handleSendForm}>Book now</div>
            </form>
          );
    }
}

export default Form;